export default class DuplicateCompanyNameError extends Error {}
